import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import {get as _get} from 'lodash';

import {getLink} from '@appComponents/Link';
import {convertToInt} from '@utils/helpers';
import mapModulesToProps from '@utils/mapModulesToProps';
import {PRODUCT_LCR} from '@constants/variables';

import ClientProductForm from './ClientProductForm';
import {deleteSuccessCallback, setClientProductsEntity} from '../utils/clientProducts';

class ClientProductLcrForm extends ClientProductForm {
    componentDidMount() {
        super.componentDidMount();

        const entityName = 'client',
            params = {
                clientData: this.props.clientData,
                entityName,
                setEntity: this.props.Entity.setEntity,
            };

        this.setCreateSuccessCallback((response) => {
            this.props.Entity.setEntity({
                name: entityName,
                data: {...this.props.clientData,
                    clientProducts: this.props.clientData.clientProducts.concat(
                        response.data.createClientProductLcr.client_product
                    ),
                },
            });

            this.props.history.push(getLink('clients.products.lcr.editGeoRestrictions', {
                id: this.props.match.params.id,
            }));
        });

        this.setUpdateSuccessCallback((response) => {
            const clientProductLcrIndex = this.props.clientData.clientProducts.findIndex(clientProduct =>
                    PRODUCT_LCR === convertToInt(clientProduct.product.id)
                ),
                clientProducts = {};

            clientProducts[clientProductLcrIndex] = {
                ...response.data.updateClientProductLcr.client_product,
            };
            params.clientProducts = clientProducts;

            setClientProductsEntity(params);
        });

        this.setDeleteSuccessCallback(() => {
            params.formParamsId = this.props.formParams.id;
            params.historyPush = this.props.history.push;

            deleteSuccessCallback(params);
        });
    }

    componentDidUpdate(prevProps) {
        const {
            formParams,
            GraphQLEntityData,
            GraphQLOptionsData,
        } = this.props;

        const isAddForm = formParams?.isAddForm;
        const clientProductsLcr = _get(GraphQLEntityData, 'clientProductsLcr', []);
        const entityLoading = _get(GraphQLEntityData, 'loading', false);
        const lcrClientTypes = _get(GraphQLOptionsData, 'lcrClientTypes', []);
        const optionsProduct = _get(GraphQLOptionsData, 'product');
        const optionsLoading = _get(GraphQLOptionsData, 'loading', false);
        let augmentedPrevProps = prevProps;

        if (!optionsLoading && !entityLoading && !this.state.dataReceived) {
            if (!isAddForm && 0 < clientProductsLcr.length) {
                augmentedPrevProps = { ...prevProps, clientProduct: clientProductsLcr[0].client_product };

                this.setField('id', {defaultValue: convertToInt(clientProductsLcr[0].id)});
                this.setField('lcr_client_types', {
                    defaultValue: clientProductsLcr[0].lcr_client_types.map(lcrClientType =>
                        convertToInt(lcrClientType.id)
                    ),
                    options: lcrClientTypes,
                });
            }

            this.handleInitialSlaFieldVisibility(isAddForm, clientProductsLcr, optionsProduct);
            super.componentDidUpdate(augmentedPrevProps);
        }
    }


    prepareDataForSubmit(data) {
        data = {...data, product: PRODUCT_LCR};

        const dataToSubmit = super.prepareDataForSubmit(data);

        return {...dataToSubmit, lcr_client_types: data.lcr_client_types};
    }
}

const mapDispatchToProps = mapModulesToProps(['Entity']),
    mapStateToProps = (state) => ({clientData: state.app.entities.client || null});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ClientProductLcrForm));
